import {GoogleAuthProvider, FacebookAuthProvider} from 'firebase/auth';

export class FormatHelper {
  private static _instance: FormatHelper | null = null;
  // TODO - this should be parametrized when website is available in multiple countries
  private locale = 'de-DE';

  private constructor() {
    return;
  }

  public setLocale(locale: string) {
    this.locale = locale;
  }

  public static get instance(): FormatHelper {
    if (!FormatHelper._instance) FormatHelper._instance = new FormatHelper();
    return FormatHelper._instance;
  }

  public authProviderFriendlyName(providerId: string | undefined): string {
    switch (providerId) {
      case GoogleAuthProvider.PROVIDER_ID:
        return 'Google';
      case FacebookAuthProvider.PROVIDER_ID:
        return 'Facebook';
      case 'apple.com':
        return 'Apple-ID';
    }

    return '';
  }

  public periodLengthDurationFriendly(periodMonths: number): string {
    let ret = '';

    const years = Math.floor(periodMonths / 12);
    const months = periodMonths % 12;

    if (years) {
      if (years === 1) ret = 'Jahr';
      else ret = years + ' Jahre';
    }

    if (months) {
      if (years) {
        ret += ' ';
      }

      if (months === 1) {
        if (years) ret = '1 Monat';
        else ret = 'Monat';
      } else {
        ret += months + ' Monate';
      }
    }

    return ret;
  }

  public getCurrencySymbol(currency: string): string {
    const currency_symbols: Record<string, string> = {
      USD: '$', // US Dollar
      EUR: '€', // Euro
      CRC: '₡', // Costa Rican Colón
      GBP: '£', // British Pound Sterling
      ILS: '₪', // Israeli New Sheqel
      INR: '₹', // Indian Rupee
      JPY: '¥', // Japanese Yen
      KRW: '₩', // South Korean Won
      NGN: '₦', // Nigerian Naira
      PHP: '₱', // Philippine Peso
      PLN: 'zł', // Polish Zloty
      PYG: '₲', // Paraguayan Guarani
      THB: '฿', // Thai Baht
      UAH: '₴', // Ukrainian Hryvnia
      VND: '₫', // Vietnamese Dong
    };

    return currency_symbols[currency] ?? currency;
  }

  /**
   *
   * @param price - price in cents
   * @param currency
   * @returns
   */
  public getPriceFormatted(price: number, currency: string): string {
    let seperator = '.';
    switch (currency) {
      case 'EUR':
        seperator = ',';
        break;
    }
    return `${(price / 100)
      .toFixed(2)
      .toString()
      .replace('.', seperator)} ${this.getCurrencySymbol(currency)}`;
  }

  public dateToDayAndMonth(date: Date): string {
    if (!Intl || !Intl.DateTimeFormat) {
      return date.toLocaleDateString(this.locale);
    }
    return new Intl.DateTimeFormat(this.locale, {
      month: 'long',
      day: 'numeric',
    }).format(date);
  }
}
